import { BrandMark } from './BrandMark';
import {
  ApiOutlined,
  LinkOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const ojServiceLinks = [
  { to: '/submissions', label: '评测记录' },
  { to: '/ranklist', label: '排行榜' },
  { to: '/schedules', label: '题单' }
];

const developerLinks = [
  { to: '/api-doc', label: 'API 文档' },
  { to: '/help', label: '使用帮助' }
];

const aboutLinks = [
  { to: '/terms', label: '服务条款' },
  { to: '/privacy', label: '隐私政策' },
  { to: '/youth', label: '青少年保护' }
];

export type SiteFooterInfo = {
  icp?: string;
  babh?: string;
  beianUrl?: string;
  publicSecurityUrl?: string;
};

export function SiteFooter({ site }: { site: SiteFooterInfo }) {

  return (
    <footer className="site-footer-v2">
      <div className="site-footer-inner">
        <section className="footer-brand-block">
          <Link to="/home" className="footer-brand-lockup" aria-label="必可">
            <BrandMark />
            <span>
              <strong>必可</strong>
            </span>
          </Link>
          <p>面向算法竞赛训练、NOI 系列赛事与 AI 辅助学习的在线评测平台</p>
          <div className="footer-contact-row">
            <a href="mailto:becoder@yeah.net">
              becoder@yeah.net
            </a>
          </div>
        </section>

        <nav className="footer-link-group" aria-label="OJ 服务">
          <div className="footer-section-title">OJ 服务</div>
          <div className="footer-link-list">
            {ojServiceLinks.map((item) => (
              <Link to={item.to} key={item.to}>{item.label}</Link>
            ))}
          </div>
        </nav>

        <nav className="footer-link-group" aria-label="开发支持">
          <div className="footer-section-title">开发支持</div>
          <div className="footer-link-list">
            {developerLinks.map((item) => (
              <Link to={item.to} key={item.to}>
                <span>{item.label}</span>
              </Link>
            ))}
            <a href="mailto:becoder@yeah.net"><span>联系我们</span></a>
          </div>
        </nav>

        <nav className="footer-link-group" aria-label="关于平台">
          <div className="footer-section-title">关于平台</div>
          <div className="footer-link-list">
            {aboutLinks.map((item) => (
              <Link to={item.to} key={item.to}>{item.label}</Link>
            ))}
          </div>
        </nav>
      </div>
      <div className="site-footer-bottom">
        <div className="footer-bottom-brand">
          <span>© 2026 必可</span>
          <span>为有品位的算法竞赛爱好者设计</span>
        </div>
        <div className="footer-bottom-records" aria-label="备案信息">
          <span>
            <img className="footer-record-police-icon" src="https://www.beian.gov.cn/img/ghs.png" alt="" aria-hidden="true" />
            <a href={site.publicSecurityUrl || 'https://www.beian.gov.cn/'} target="_blank" rel="noreferrer">{site.babh || '公安备案信息'}</a>
          </span>
          <span>
            <LinkOutlined />
            <a href={site.beianUrl || 'https://beian.miit.gov.cn/'} target="_blank" rel="noreferrer">{site.icp || 'ICP备案信息'}</a>
          </span>
          <span><SafetyCertificateOutlined />版权所属：必可</span>
        </div>
      </div>
    </footer>
  );
}
